import React, { useEffect, useState } from 'react'
import { AppDrawer } from '@/components/YhDrawer'
import { useMergerModel } from './summaryModel'
import { message, Select, Table } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import { ColumnsType } from 'antd/lib/table'
import { ICustomerAccountSummary, ICustomerMergeBindData } from '../../../AccountTypes'
import { useLockFn } from 'ahooks'
import { ISearchPage, ISelectOption } from '@/types/FmsTypes'
import { accountShopService } from '@/views/account/AccountShopService'
import debounce from 'lodash/debounce'
import YhDebounceSelect from '@/components/YhDounceSelect'
import useGlobalModel from '@/model/globalModel'
import { accountService } from '@/views/account/AccountService'
import { DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'

interface Icustoermer {
    key: string
    id: string
    label: string
    value: string
}

export const MergerDrawer = () => {
    const { mergerInfo, setMergerInfo, loadData } = useMergerModel()
    const {
        fetchCustomerList,
        user: { shopCode },
    } = useGlobalModel()

	//初始页数
	const defaultPage = { pageSize: 20, pageNum: DEFAULT_FIRST_PAGE_NUM };
	//实时查询客户接口
	const queryCustomerList = async (value: string) => {
		let data = {
			name: value,
			page: defaultPage,
            shopCode,
		};
		return accountShopService.customerSummaryPage(data).then((res) => {
			const {
				retData: { records },
			} = res;
			return records
				? records.map((el) => ({
					key: el.key ?? '',
					id: el.key ?? '',
					label: el.name ?? '',
					value: el.code ?? '',
				}))
				: [];
		});
	};
    useEffect(() => {
        if(mergerInfo.visible && mergerInfo.id){
            accountService.customerMergeOne(mergerInfo.id).then(res => {
                let custermers = res.retData?.map(item => {
                    let info = {
                        key: item.id,
                        id: item.id,
                        label: item.customerName,
                        value: item.customerCode
                    }
                    if(item.main){
                        setSelectedRowKeys([info])
                    }
                    return info
                })
                setCustermerList(custermers)
            })
        }
    }, [mergerInfo.visible])

    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<Icustoermer[]>([])

    const [custermerList, setCustermerList] = useState<Icustoermer[]>([])

    const onOk = useLockFn(async () => {
        if (!selectedRowKeys || selectedRowKeys.length !== 1) {
            return message.error('请选择主客户！')
        }
        if (custermerList.length < 2) {
            return message.error('请至少选择两个客户进行合并')
        }
        console.log(selectedRowKeys[0])
        console.log(custermerList)

        let data: ICustomerMergeBindData = {
            shopCode,
            customers: custermerList.map((item) => ({ customerCode: item.value, main: +(item.key === selectedRowKeys[0].key) })),
        }
        if (mergerInfo.mode === 'edit') {
            data.id = mergerInfo.id
        }
        accountService.customerMergeBind(data).then((res) => {
            if (res && res.retData) {
                message.success('操作成功')
                setMergerInfo({visible:false})
                loadData()
            }
        })
    })

    const onCancel = () => {
        setMergerInfo({ visible: false })
    }

    const columns: ColumnsType<Icustoermer> = [
        {
            title: '序号',
            width: 66,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            align: 'center',
            title: '客户名称',
            dataIndex: 'label',
        },
        {
            align: 'center',
            title: '客户编码',
            dataIndex: 'value',
        },
        {
            title: '操作',
            width: 80,
            align: 'center',
            render: (text, record) => (
                <MinusCircleOutlined
                    className="dynamic-delete-button"
                    onClick={(e) => {
                        e.stopPropagation()
                        let filterData = custermerList.filter((item) => item.key !== record.key)
                        setCustermerList([...filterData])
                        if (record.key === selectedRowKeys[0]?.key) {
                            setSelectedRowKeys([])
                        }
                    }}
                />
            ),
        },
    ]

    //点击行选高亮
    const onRow = (record: Icustoermer) => {
        setSelectedRowKeys([record])
    }

    return (
        <AppDrawer
            {...{
                title: '客户合并',
                width: 900,
                visible: mergerInfo.visible,
                closable: true,
                onOk,
                onCancel,
                showFooter: true,
            }}
        >
            <p>合并之后，原客户下的账户信息账单信息等其他信息都将合并到主客户中，请谨慎合并</p>
            <YhDebounceSelect
                showSearch
                allowClear
                className="ant-select-round"
                value={undefined}
                placeholder="请输入客户名称进行检索"
                fetchOptions={queryCustomerList}
                onChange={(value, option) => {
                    if (value && custermerList.findIndex(i => i.value === value) === -1) {
                        setCustermerList([...custermerList, option as Icustoermer])
                    }
                }}
                style={{ width: '100%', marginBottom: '20px' }}
            />

            <Table
                rowSelection={{
                    type: 'radio',
                    onSelect: (record, selected, selectedRows) => {
                        onRow(record)
                    },
                    selectedRowKeys: selectedRowKeys.map((item) => item.key),
                }}
                onRow={(record) => ({
                    onClick: () => onRow(record),
                })}
                columns={columns}
                dataSource={custermerList}
                pagination={false}
            />
        </AppDrawer>
    )
}
